import { render, staticRenderFns } from "./gecicivergi.vue?vue&type=template&id=33a6fae2&"
import script from "./gecicivergi.vue?vue&type=script&lang=js&"
export * from "./gecicivergi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports